<template>
    <app-popover v-bind="popoverProps" :useScroll="true" :disabled="disabled">
        <template slot="triggerer">
            <slot>
            </slot>
        </template>
        <template slot="content">
            <div style="width: 250px; height: 150px;">
                <div class="emoji-label">
                    Emojis
                </div>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('Smileys & Emotion (face-smiling)') === 0)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('Smileys & Emotion (face-negative)') === 0)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('Smileys & Emotion (face-affection)') === 0 || _emoji.category.indexOf('Smileys & Emotion (emotion)') === 0)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('Smileys & Emotion (face-concerned)') === 0)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('People & Body (hand-fingers-closed)') === 0 && _emoji.name.indexOf('skin tone') === -1)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('People & Body (hands)') === 0 && _emoji.name.indexOf('skin tone') === -1)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('People & Body (hand-fingers-partial)') === 0 && _emoji.name.indexOf('skin tone') === -1)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('People & Body (hand-fingers-open)') === 0 && _emoji.name.indexOf('skin tone') === -1)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
                <ul class="emoji-list">
                    <li v-for="emoji of emojis.filter(_emoji => _emoji.category.indexOf('Smileys & Emotion (face-costume)') === 0)" 
                        :key="emoji.code"
                        class="emoji-item"    
                        @click="$emit('selectEmoji', emoji)"
                    >
                        {{ emoji.char }}
                    </li>                
                </ul>
            </div>
        </template>
    </app-popover>
</template>
<script>
    import Vue from "vue";
    import _ from "lodash";
    import Popper from "popper.js";

    import emojis from './emoji.json'
    export default {
        data() {
            return {
                popperInstance: null,
                closeTimeout: null,
                isShowing: false,
                inputValue: null,
                emojis: []
            };
        },
        props: [
            "value",
            "sections",
            "items",
            "title",
            "verticalOffset",
            "horizontalOffset",
            "multiple",
            "popoverProps",
            'disabled',
            'downIcon',
            'upIcon'
        ],
        computed: {},
        methods: {
            onMouseOver() {
                if (this.closeTimeout) {
                    clearTimeout(this.closeTimeout);
                }
            },
            onMouseLeave() {
                this.closeTimeout = setTimeout(() => {
                    this.closeSelect();
                }, 1200);
            },
            onClickTarget() {
                this.openSelect();
            },
            onClick(ev) {
                const vm = this;
                if (
                    vm.isShowing &&
                    vm.$refs.container &&
                    ((vm.$refs.container !== ev.target &&
                        !vm.$refs.container.contains(ev.target)) ||
                        ev.target === vm.$refs.closeButton ||
                        vm.$refs.closeButton.contains(ev.target))
                ) {
                    vm.closeSelect();
                }
            },
            openSelect() {
                this.isShowing = true;
                /*document.addEventListener("click", this.onClick);*/
                Vue.nextTick(() => {
                    if (this.popperInstance) {
                        this.popperInstance.destroy();
                    }
                    this.popperInstance = new Popper(
                        this.$refs.target,
                        this.$refs.container,
                        {
                            placement: "bottom-start",
                            modifiers: {
                                flip: {
                                    enabled: false
                                }
                            }
                        }
                    );
                });
            },
            closeSelect() {
                this.isShowing = false;
            },
            toggleSelect() {
                if (this.isShowing) return this.closeSelect();
                this.openSelect();
            },
            itemSelected(item) {
                if (!this.multiple) {
                    // single select
                    if (this.value === item.value) {
                        this.onValueChanged(null);
                        this.$emit("unselect", item.value);
                    } else {
                        this.onValueChanged(item.value);
                        this.$emit("select", item.value);
                    }
                } else {
                    // multiple select
                    if (_.includes(this.value, item.value)) {
                        this.value.splice(_.findIndex(this.value, item.value),1)
                        this.onValueChanged(this.value);
                        this.$emit("unselect", item.value);
                    } else {
                        this.value.push(item.value)
                        this.onValueChanged(this.value);
                        this.$emit("select", item.value);
                    }
                }
                this.closeSelect();
            },
            saveInput() {
                this.$emit("save", this.inputValue);
            },
            onValueChanged(value) {
                this.$emit("input", value);
                this.$emit("change", value);
            }
        },
        mounted() {
            this.emojis = emojis
        }
    };
</script>

<style lang="scss">
    .select-input__container {
    }
    .container__close-button {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 15px;
        height: 15px;
        padding: 0;
        display: flex;
        font-size: 10px;
        justify-content: center;
        align-items: center;
        border-radius: 100%;
        line-height: 100%;
        background-color: var(--bg-color--7);
        color: var(--font-color);
    }
    .container__section {
        margin-bottom: 10px;
    }
    .container__section:last-child {
        margin-bottom: 0;
    }
    .section__item,
    .container__items .items__item {
        display: flex;
        flex-direction: row;
        cursor: pointer;
        padding: 8px 0;
        height: 32px;
    }
    .ag-select-input .section__item span {
        color: var(--base-color);
    }
    .ag-select-input .container__items {
        display: flex;
        flex-direction: column;
    }
    .select-input__container h3 {
        color: var(--secondary-color--d);
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-bottom: 8px;
    }
    .container__items .items__item span {
        color: var(--base-color);
    }
    .container__items .items__item >>> .colorizable {
        fill: var(--font-color--secondary);
    }
    .container__input {
        margin-top: 10px;
        position: relative;
    }
    .container__input input {
        font-size: 12px;
    }

    .emoji-list {
        margin-top: 1px;
        display: flex; 
        flex-wrap: wrap; 
        justify-content: space-between;
        background: rgba(49, 54, 60, 0.555);
        // border: solid #31363C 2px;
        padding: 10px;
        align-self: flex-start;
    }

    .emoji-label {
        color: #C3C5C6;
        background: rgba(42, 46, 51, 0.87);
        border-radius: 5px 5px 0 0;
        padding: 5px 15px;
        margin-bottom: 1px;
    }

    .emoji-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 35px;
        font-size: 1.8em;
        border-radius: 50%;
        transition: .05s;
        opacity: .8;
        cursor: pointer;
        &:hover {
            opacity: 1;
            font-size: 2.2em;
        }
    }

</style>
